import React, { ReactElement } from 'react';
import { Flex } from '@edreamsodigeo/prisma-design-system';
import ThreeColumnsItineraryPrice from '../ThreeColumnsItineraryPrice/ThreeColumnsItineraryPrice';

const PriceColumnStandard = ({
  itinerary,
  PriceDescription,
  hasRetailingTechniques = true,
  isAlternativeItinerary,
  isAlternativeItineraryOnModal,
}): ReactElement => {
  return (
    <Flex flexDirection="row" alignItems="flex-end" flex="auto">
      <Flex
        flexDirection="row"
        flex={'auto'}
        alignItems={'flex-end'}
        justifyItems={'flex-end'}
        justifyContent={'flex-end'}
      >
        <ThreeColumnsItineraryPrice
          itinerary={itinerary}
          PriceDescription={PriceDescription}
          hasRetailingTechniques={hasRetailingTechniques}
          isAlternativeItinerary={isAlternativeItinerary}
          isAlternativeItineraryOnModal={isAlternativeItineraryOnModal}
        />
      </Flex>
    </Flex>
  );
};

export default PriceColumnStandard;
